import { Menu, MenuItem, styled } from '@mui/material';

export const ActionMenuBase = styled(Menu)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    [theme.breakpoints.up('sm')]: {
      backgroundColor: 'transparent',
    },
  },

  '& .MuiMenu-paper': {
    boxShadow: theme.palette.case.shadow.default,
    padding: '4px',
    border: `0.5px solid ${theme.palette.case.neutral.n200}`,

    backgroundColor: theme.palette.case.background,
    '& .MuiList-root': {
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      backgroundColor: 'transparent',
      width: '100%',
      maxWidth: '100%',
      top: 'auto !important',
      bottom: '10px',
      left: '0px !important',
      right: '0px !important',
      padding: '0',
    },
  },
}));

export const ActionMenuBaseItem = styled(MenuItem)<{ disabled?: boolean }>(({ theme, disabled = false }) => ({
  boxShadow: 'none',
  borderRadius: '4px',
  width: '200px',
  height: '36px',
  padding: '8px',
  backgroundColor: theme.palette.case.background,
  svg: {
    width: '20px',
    height: '20px',
    marginRight: '8px',
    path: {
      fill: disabled ? theme.palette.case.neutral.n400 : theme.palette.case.neutral.n500,
    },
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '100%',
    marginBottom: '10px',
  },
  '&:hover': {
    backgroundColor: theme.palette.case.neutral.n75,
  },
  '&:active': {
    backgroundColor: theme.palette.case.neutral.n100,
  },
  '&.Mui-disabled': {
    opacity: 1,
    backgroundColor: theme.palette.case.background,
    color: theme.palette.case.neutral.n400,
    cursor: 'not-allowed !important',
  },
}));
